import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSONString: { input: string; output: string; }
};

export type AdminDashboardQuery = {
  get?: Maybe<DashboardGetType>;
  instances?: Maybe<Array<Maybe<InstanceOverviewType>>>;
};


export type AdminDashboardQueryGetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeviceCreateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminDeviceDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminDeviceMutations = {
  create?: Maybe<AdminDeviceCreateMutation>;
  delete?: Maybe<AdminDeviceDeleteMutation>;
  update?: Maybe<AdminDeviceUpdateMutation>;
};


export type AdminDeviceMutationsCreateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  user?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
};


export type AdminDeviceMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type AdminDeviceMutationsUpdateArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AdminDeviceQuery = {
  detail?: Maybe<DeviceType>;
  list?: Maybe<Array<Maybe<DeviceType>>>;
};


export type AdminDeviceQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeviceUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminEventCreateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminEventDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminEventMutations = {
  create?: Maybe<AdminEventCreateMutation>;
  delete?: Maybe<AdminEventDeleteMutation>;
  update?: Maybe<AdminEventUpdateMutation>;
};


export type AdminEventMutationsCreateArgs = {
  endAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
};


export type AdminEventMutationsDeleteArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminEventMutationsUpdateArgs = {
  endAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEventQuery = {
  detail?: Maybe<EventType>;
  list?: Maybe<Array<Maybe<EventType>>>;
};


export type AdminEventQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminEventUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminMutations = {
  device?: Maybe<AdminDeviceMutations>;
  event?: Maybe<AdminEventMutations>;
  ticket?: Maybe<AdminTicketMutations>;
  ticketset?: Maybe<AdminTicketsetMutations>;
  user?: Maybe<AdminUserMutations>;
};

export type AdminQuery = {
  dashboard?: Maybe<AdminDashboardQuery>;
  device?: Maybe<AdminDeviceQuery>;
  event?: Maybe<AdminEventQuery>;
  statistics?: Maybe<AdminStatisticsQuery>;
  ticket?: Maybe<AdminTicketQuery>;
  ticketset?: Maybe<AdminTicketsetQuery>;
  user?: Maybe<AdminUserQuery>;
  zones?: Maybe<AdminZoneQuery>;
};

export type AdminStatisticsQuery = {
  get?: Maybe<StatisticsType>;
};


export type AdminStatisticsQueryGetArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  devices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  interval?: InputMaybe<StatisticsIntervalEnum>;
  showEmptyTicketsets?: InputMaybe<Scalars['Boolean']['input']>;
  slots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AdminTicketDeleteMultiMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminTicketDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminTicketMutations = {
  delete?: Maybe<AdminTicketDeleteMutation>;
  deleteMulti?: Maybe<AdminTicketDeleteMultiMutation>;
  update?: Maybe<AdminTicketUpdateMutation>;
  /**
   * Import vstupenek — atomický: buď projde všechno, nebo se nezapíše nic.
   *
   * Dvě fáze. Nejdřív se zvaliduje celý vstup a posbírají se všechny chyby;
   * teprve když je čistý, zapisuje se. Duplicita (stejný `code` v téže ceně)
   * není chyba — přeskočí se, aby opakovaný import téhož souboru prošel.
   */
  upload?: Maybe<AdminTicketUploadMutation>;
};


export type AdminTicketMutationsDeleteArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminTicketMutationsDeleteMultiArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type AdminTicketMutationsUpdateArgs = {
  boughtAt?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['Int']['input']>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  usedAt?: InputMaybe<Scalars['String']['input']>;
  usedById?: InputMaybe<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};


export type AdminTicketMutationsUploadArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  ticketsJson?: InputMaybe<Scalars['String']['input']>;
};

export type AdminTicketQuery = {
  detail?: Maybe<TicketType>;
  infoData?: Maybe<TicketInfoDataType>;
  list?: Maybe<TicketTypeConnection>;
};


export type AdminTicketQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminTicketQueryInfoDataArgs = {
  code: Scalars['String']['input'];
};


export type AdminTicketQueryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  ticketset?: InputMaybe<Scalars['ID']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminTicketUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Import vstupenek — atomický: buď projde všechno, nebo se nezapíše nic.
 *
 * Dvě fáze. Nejdřív se zvaliduje celý vstup a posbírají se všechny chyby;
 * teprve když je čistý, zapisuje se. Duplicita (stejný `code` v téže ceně)
 * není chyba — přeskočí se, aby opakovaný import téhož souboru prošel.
 */
export type AdminTicketUploadMutation = {
  created: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  errors: Array<ImportRowError>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  pricesCreated: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  ticketsetsCreated: Scalars['Int']['output'];
};

export type AdminTicketsetMutations = {
  update?: Maybe<AdminTicketsetUpdateMutation>;
};


export type AdminTicketsetMutationsUpdateArgs = {
  customName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  validate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminTicketsetQuery = {
  list?: Maybe<Array<Maybe<TicketsetType>>>;
};


export type AdminTicketsetQueryListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AdminTicketsetUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserChangeInstanceMutation = {
  instanceId?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  rights?: Maybe<InstanceUserRightsType>;
};

export type AdminUserDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserLoginMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<UserType>;
};

export type AdminUserLogoutMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserMutations = {
  changeInstance?: Maybe<AdminUserChangeInstanceMutation>;
  delete?: Maybe<AdminUserDeleteMutation>;
  login?: Maybe<AdminUserLoginMutation>;
  logout?: Maybe<AdminUserLogoutMutation>;
  update?: Maybe<AdminUserUpdateMutation>;
  updateRights?: Maybe<AdminUserUpdateRightsMutation>;
};


export type AdminUserMutationsChangeInstanceArgs = {
  instanceName: Scalars['String']['input'];
};


export type AdminUserMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type AdminUserMutationsLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type AdminUserMutationsUpdateArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};


export type AdminUserMutationsUpdateRightsArgs = {
  allowManageDevices?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageEvents?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageTickets?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageTicketsets?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageUsers?: InputMaybe<Scalars['Boolean']['input']>;
  allowStats?: InputMaybe<Scalars['Boolean']['input']>;
  bzucoAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  instanceId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type AdminUserQuery = {
  detail?: Maybe<UserType>;
  list?: Maybe<Array<Maybe<UserType>>>;
  logged?: Maybe<UserType>;
  zones?: Maybe<Array<Maybe<ZoneType>>>;
};


export type AdminUserQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminUserUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserUpdateRightsMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminZoneQuery = {
  list?: Maybe<Array<Maybe<ZoneType>>>;
};

export type AlertType = {
  kind?: Maybe<Scalars['String']['output']>;
  relatedId?: Maybe<Scalars['Int']['output']>;
  relatedName?: Maybe<Scalars['String']['output']>;
  relatedType?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

export type CheckpointType = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ticketsets: Array<TicketsetType>;
  user: UserType;
};

export type DashboardEventType = {
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scanRateLastHour?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  ticketsTotal?: Maybe<Scalars['Int']['output']>;
  ticketsUsed?: Maybe<Scalars['Int']['output']>;
};

export type DashboardGetType = {
  activeDevicesCount?: Maybe<Scalars['Int']['output']>;
  activeEvents?: Maybe<Array<Maybe<DashboardEventType>>>;
  alerts?: Maybe<Array<Maybe<AlertType>>>;
  hourlyValidations?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  recentScans?: Maybe<Array<Maybe<ScanLogType>>>;
  ticketsTotal?: Maybe<Scalars['Int']['output']>;
  ticketsUsed?: Maybe<Scalars['Int']['output']>;
  totalDevicesCount?: Maybe<Scalars['Int']['output']>;
  upcomingEventsCount?: Maybe<Scalars['Int']['output']>;
  validationsLast24h?: Maybe<Scalars['Int']['output']>;
  validationsPrev24h?: Maybe<Scalars['Int']['output']>;
};

export type DeviceType = {
  id?: Maybe<Scalars['Int']['output']>;
  instance?: Maybe<InstanceType>;
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  ticketSet: TicketTypeConnection;
  username: Scalars['String']['output'];
};


export type DeviceTypeTicketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EventType = {
  bzucoId: Scalars['Int']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instance?: Maybe<InstanceType>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
  ticketsets: Array<TicketsetType>;
};

export type ImportRowError = {
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type InstanceOverviewType = {
  activeEventsCount?: Maybe<Scalars['Int']['output']>;
  devicesOnline?: Maybe<Scalars['Int']['output']>;
  devicesTotal?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scansLast24h?: Maybe<Scalars['Int']['output']>;
};

export type InstanceType = {
  devices: Array<DeviceType>;
  events: Array<EventType>;
  id: Scalars['ID']['output'];
  instanceuserrightsSet: Array<InstanceUserRightsType>;
  name: Scalars['String']['output'];
  users: Array<UserType>;
  zones: Array<ZoneType>;
};

export type InstanceUserRightsType = {
  allowManageDevices: Scalars['Boolean']['output'];
  allowManageEvents: Scalars['Boolean']['output'];
  allowManageTickets: Scalars['Boolean']['output'];
  allowManageTicketsets: Scalars['Boolean']['output'];
  allowManageUsers: Scalars['Boolean']['output'];
  allowStats: Scalars['Boolean']['output'];
  bzucoAdmin: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instance: InstanceType;
  primary: Scalars['Boolean']['output'];
  user: UserType;
};

export type MobileLoginMutation = {
  device?: Maybe<DeviceType>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileLogoutMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileMutations = {
  login?: Maybe<MobileLoginMutation>;
  logout?: Maybe<MobileLogoutMutation>;
  ticketDirectUseOnline?: Maybe<MobileTicketDirectUseOnlineMutation>;
  ticketUse?: Maybe<MobileTicketUseMutation>;
  ticketUseOnline?: Maybe<MobileTicketUseOnlineMutation>;
  ticketsReset?: Maybe<MobileTicketsResetMutation>;
};


export type MobileMutationsLoginArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MobileMutationsTicketDirectUseOnlineArgs = {
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  ticketsetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileMutationsTicketUseArgs = {
  code: Scalars['String']['input'];
  ticketsetId: Scalars['Int']['input'];
};


export type MobileMutationsTicketUseOnlineArgs = {
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  ticketsetId: Scalars['Int']['input'];
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileMutationsTicketsResetArgs = {
  ticketsetId?: InputMaybe<Scalars['Int']['input']>;
};

export type MobileQuery = {
  events?: Maybe<Array<Maybe<EventType>>>;
  info?: Maybe<Scalars['String']['output']>;
  infoData?: Maybe<TicketInfoDataType>;
  online?: Maybe<TicketOnlineType>;
  tickets?: Maybe<Array<Maybe<TicketsTicketsetType>>>;
  ticketsReader?: Maybe<Scalars['JSONString']['output']>;
  ticketsUpdated?: Maybe<Array<Maybe<TicketsTicketsetType>>>;
  userLogged?: Maybe<UserLoggedQueryType>;
  zoneStats?: Maybe<Array<Maybe<ZoneStatsType>>>;
  zones?: Maybe<Array<Maybe<ZoneType>>>;
};


export type MobileQueryEventsArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MobileQueryInfoArgs = {
  code: Scalars['String']['input'];
};


export type MobileQueryInfoDataArgs = {
  code: Scalars['String']['input'];
};


export type MobileQueryOnlineArgs = {
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  ticketsetId: Scalars['Int']['input'];
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryTicketsArgs = {
  checkpointId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  ticketsetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryTicketsReaderArgs = {
  ticketsetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryTicketsUpdatedArgs = {
  checkpointId?: InputMaybe<Scalars['Int']['input']>;
  ticketsets?: InputMaybe<Array<InputMaybe<Scalars['JSONString']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryZoneStatsArgs = {
  day?: InputMaybe<Scalars['Date']['input']>;
};

export type MobileTicketDirectUseOnlineMutation = {
  display?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  ticket?: Maybe<TicketType>;
};

export type MobileTicketUseMutation = {
  display?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileTicketUseOnlineMutation = {
  display?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<Scalars['String']['output']>;
};

export type MobileTicketsResetMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutations = {
  admin?: Maybe<AdminMutations>;
  mobile?: Maybe<MobileMutations>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PriceType = {
  bzucoId: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  people: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  tickets: TicketTypeConnection;
  ticketset: TicketsetType;
  title: Scalars['String']['output'];
};


export type PriceTypeTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  admin?: Maybe<AdminQuery>;
  mobile?: Maybe<MobileQuery>;
};

export type ScanLogType = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ticketCode?: Maybe<Scalars['String']['output']>;
  ticketsetName?: Maybe<Scalars['String']['output']>;
};

export type SlotType = {
  bzucoId: Scalars['Int']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lang: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  validSince?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  zone: ZoneType;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export type StatisticsDeviceType = {
  count?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export enum StatisticsIntervalEnum {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

export type StatisticsTicketsetSumSubType = {
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StatisticsTicketsetSumType = {
  eventName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  real?: Maybe<Scalars['Int']['output']>;
  realNodevice?: Maybe<Scalars['Int']['output']>;
  sub?: Maybe<Array<Maybe<StatisticsTicketsetSumSubType>>>;
  total?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type StatisticsType = {
  device?: Maybe<Array<Maybe<StatisticsDeviceType>>>;
  interval?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  misc?: Maybe<Scalars['JSONString']['output']>;
  ticketsTotal?: Maybe<Scalars['Int']['output']>;
  ticketsValidated?: Maybe<Scalars['Int']['output']>;
  ticketsetSums?: Maybe<Array<Maybe<StatisticsTicketsetSumType>>>;
  ticketsetSumsTotal?: Maybe<StatisticsTicketsetSumType>;
};

export type TicketInfoDataLogType = {
  created?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Scalars['Int']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['Int']['output']>;
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataRemainType = {
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataSlotType = {
  bzucoId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataType = {
  created?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Scalars['Int']['output']>;
  entryPause?: Maybe<Scalars['Int']['output']>;
  eventBzucoId?: Maybe<Scalars['Int']['output']>;
  eventId?: Maybe<Scalars['Int']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  people?: Maybe<Scalars['Int']['output']>;
  priceBzucoId?: Maybe<Scalars['Int']['output']>;
  priceId?: Maybe<Scalars['Int']['output']>;
  priceName?: Maybe<Scalars['String']['output']>;
  remainingEntriesForZone?: Maybe<Array<Maybe<TicketInfoDataRemainType>>>;
  remainingPeopleForZone?: Maybe<Array<Maybe<TicketInfoDataRemainType>>>;
  slots?: Maybe<Array<Maybe<TicketInfoDataSlotType>>>;
  ticketsetBzucoId?: Maybe<Scalars['Int']['output']>;
  ticketsetId?: Maybe<Scalars['Int']['output']>;
  ticketsetName?: Maybe<Scalars['String']['output']>;
  usageForZone?: Maybe<Array<Maybe<TicketInfoDataUsageType>>>;
  usageLogs?: Maybe<Array<Maybe<TicketInfoDataLogType>>>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  zones?: Maybe<Array<Maybe<TicketInfoDataZoneType>>>;
};

export type TicketInfoDataUsageType = {
  display?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Scalars['Int']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextEntryAt?: Maybe<Scalars['String']['output']>;
  remains?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  usedBy?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataZoneType = {
  bzucoId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TicketOnlineType = {
  display?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  ticketset?: Maybe<TicketsetType>;
  used?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<Scalars['String']['output']>;
  zonesUsed?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type TicketType = Node & {
  boughtAt?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  price?: Maybe<PriceType>;
  slotValidSince?: Maybe<Scalars['JSONString']['output']>;
  slotValidUntil?: Maybe<Scalars['JSONString']['output']>;
  slots: Scalars['String']['output'];
  ticketNumber: Scalars['String']['output'];
  ticketset?: Maybe<TicketsetType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedAtString?: Maybe<Scalars['String']['output']>;
  used: Scalars['Boolean']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAtString?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<DeviceType>;
  usedOnCheckpoint?: Maybe<Scalars['Boolean']['output']>;
  usedTotal: Scalars['Int']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  zoneList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  zones: Scalars['String']['output'];
};

export type TicketTypeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketType` and its cursor. */
export type TicketTypeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketType>;
};

export type TicketsTicketsetType = {
  tickets?: Maybe<Array<Maybe<TicketType>>>;
  ticketsetId?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TicketsetType = {
  bzucoId: Scalars['Int']['output'];
  checkpointSet: Array<CheckpointType>;
  customName: Scalars['String']['output'];
  entries: Scalars['Int']['output'];
  entryPause: Scalars['Int']['output'];
  event: EventType;
  id?: Maybe<Scalars['Int']['output']>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  prices: Array<PriceType>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  unlimited: Scalars['Boolean']['output'];
  validate: Scalars['Boolean']['output'];
  validatedCount?: Maybe<Scalars['Int']['output']>;
};

export type UserLoggedQueryType = {
  device?: Maybe<DeviceType>;
  user?: Maybe<UserType>;
};

export type UserProfileType = {
  bzucoAdmin: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instance: Scalars['String']['output'];
  user: UserType;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type UserType = {
  activeInstance?: Maybe<InstanceType>;
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  instances?: Maybe<Array<Maybe<InstanceUserRightsType>>>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  password: Scalars['String']['output'];
  profile?: Maybe<UserProfileType>;
  rights?: Maybe<InstanceUserRightsType>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
};

export type ZoneStatsType = {
  name?: Maybe<Scalars['String']['output']>;
  today?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ZoneType = {
  bzucoId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instance?: Maybe<InstanceType>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slots: Array<SlotType>;
  validSince: Scalars['Int']['output'];
  validUntil: Scalars['Int']['output'];
};

export type AdminChangeInstanceMutationVariables = Exact<{
  instanceName: Scalars['String']['input'];
}>;


export type AdminChangeInstanceMutation = { admin?: { user?: { changeInstance?: { ok?: boolean | null, instanceId?: number | null, rights?: { allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean } | null } | null } | null } | null };

export type AdminCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminCurrentUserQuery = { admin?: { user?: { logged?: { id?: number | null, username: string, firstName: string, lastName: string, email: string, isSuperuser: boolean, activeInstance?: { id: string, name: string } | null, instances?: Array<{ id: string, primary: boolean, bzucoAdmin: boolean, allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean, instance: { id: string, name: string } } | null> | null, rights?: { allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean } | null } | null } | null } | null };

export type LoggedUserFragment = { id?: number | null, username: string, firstName: string, lastName: string, email: string, isSuperuser: boolean, activeInstance?: { id: string, name: string } | null, instances?: Array<{ id: string, primary: boolean, bzucoAdmin: boolean, allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean, instance: { id: string, name: string } } | null> | null, rights?: { allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean } | null };

export type AdminLoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AdminLoginMutation = { admin?: { user?: { login?: { ok?: boolean | null, user?: { id?: number | null, username: string, firstName: string, lastName: string, email: string, isSuperuser: boolean, activeInstance?: { id: string, name: string } | null, instances?: Array<{ id: string, primary: boolean, bzucoAdmin: boolean, allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean, instance: { id: string, name: string } } | null> | null, rights?: { allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean } | null } | null } | null } | null } | null };

export type AdminLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminLogoutMutation = { admin?: { user?: { logout?: { ok?: boolean | null } | null } | null } | null };

export type AdminDashboardGetQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminDashboardGetQuery = { admin?: { dashboard?: { get?: { validationsLast24h?: number | null, validationsPrev24h?: number | null, hourlyValidations?: Array<number | null> | null, ticketsTotal?: number | null, ticketsUsed?: number | null, activeDevicesCount?: number | null, totalDevicesCount?: number | null, upcomingEventsCount?: number | null, activeEvents?: Array<{ id?: number | null, name?: string | null, startAt?: string | null, endAt?: string | null, ticketsTotal?: number | null, ticketsUsed?: number | null, scanRateLastHour?: number | null } | null> | null, recentScans?: Array<{ id?: string | null, createdAt?: string | null, deviceName?: string | null, ticketCode?: string | null, ticketsetName?: string | null, eventName?: string | null } | null> | null, alerts?: Array<{ kind?: string | null, severity?: string | null, relatedId?: number | null, relatedType?: string | null, relatedName?: string | null } | null> | null } | null, instances?: Array<{ id?: number | null, name?: string | null, activeEventsCount?: number | null, scansLast24h?: number | null, devicesOnline?: number | null, devicesTotal?: number | null } | null> | null } | null } | null };

export type AdminDeviceCredentialsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminDeviceCredentialsQuery = { admin?: { device?: { detail?: { id?: number | null, username: string, password: string } | null } | null } | null };

export type AdminDevicesListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminDevicesListQuery = { admin?: { device?: { list?: Array<{ id?: number | null, name: string, username: string } | null> | null } | null } | null };

export type AdminDeviceDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminDeviceDetailQuery = { admin?: { device?: { detail?: { id?: number | null, name: string, username: string } | null } | null } | null };

export type AdminCreateDeviceMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AdminCreateDeviceMutation = { admin?: { device?: { create?: { ok?: boolean | null } | null } | null } | null };

export type AdminUpdateDeviceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUpdateDeviceMutation = { admin?: { device?: { update?: { ok?: boolean | null } | null } | null } | null };

export type AdminDeleteDeviceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminDeleteDeviceMutation = { admin?: { device?: { delete?: { ok?: boolean | null } | null } | null } | null };

export type AdminEventsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminEventsListQuery = { admin?: { event?: { list?: Array<{ id?: number | null, name: string, startAt?: string | null, endAt?: string | null, bzucoId: number } | null> | null } | null } | null };

export type AdminEventDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminEventDetailQuery = { admin?: { event?: { detail?: { id?: number | null, name: string, startAt?: string | null, endAt?: string | null, bzucoId: number } | null } | null } | null };

export type AdminCreateEventMutationVariables = Exact<{
  name: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminCreateEventMutation = { admin?: { event?: { create?: { ok?: boolean | null } | null } | null } | null };

export type AdminUpdateEventMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUpdateEventMutation = { admin?: { event?: { update?: { ok?: boolean | null } | null } | null } | null };

export type AdminDeleteEventMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminDeleteEventMutation = { admin?: { event?: { delete?: { ok?: boolean | null } | null } | null } | null };

export type AdminLookupDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLookupDevicesQuery = { admin?: { device?: { list?: Array<{ id?: number | null, name: string, username: string } | null> | null } | null } | null };

export type AdminLookupEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLookupEventsQuery = { admin?: { event?: { list?: Array<{ id?: number | null, name: string } | null> | null } | null } | null };

export type AdminLookupTicketsetsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLookupTicketsetsQuery = { admin?: { ticketset?: { list?: Array<{ id?: number | null, name: string, bzucoId: number, event: { id?: number | null }, prices: Array<{ id?: number | null, name: string, bzucoId: number }> } | null> | null } | null } | null };

export type AdminStatisticsGetQueryVariables = Exact<{
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  devices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  interval?: InputMaybe<StatisticsIntervalEnum>;
  showEmptyTicketsets?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminStatisticsGetQuery = { admin?: { statistics?: { get?: { ticketsTotal?: number | null, ticketsValidated?: number | null, labels?: Array<string | null> | null, device?: Array<{ id?: number | null, username?: string | null, name?: string | null, values?: Array<number | null> | null, count?: string | null } | null> | null, ticketsetSums?: Array<{ id?: number | null, total?: number | null, used?: number | null, real?: number | null, realNodevice?: number | null, eventName?: string | null, name?: string | null, sub?: Array<{ id?: number | null, name?: string | null, count?: number | null, type?: string | null } | null> | null } | null> | null, ticketsetSumsTotal?: { id?: number | null, total?: number | null, used?: number | null, real?: number | null, realNodevice?: number | null, name?: string | null, eventName?: string | null } | null } | null } | null } | null };

export type AdminDeleteTicketMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminDeleteTicketMutation = { admin?: { ticket?: { delete?: { ok?: boolean | null } | null } | null } | null };

export type AdminDeleteTicketsMultiMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminDeleteTicketsMultiMutation = { admin?: { ticket?: { deleteMulti?: { ok?: boolean | null } | null } | null } | null };

export type AdminTicketDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminTicketDetailQuery = { admin?: { ticket?: { detail?: { ticketNumber: string, validUntil?: string | null, id: string, code: string, used: boolean, usedAt?: string | null, firstName: string, lastName: string, email: string, phone: string, boughtAt?: string | null, ticketset?: { id?: number | null, name: string, event: { id?: number | null, name: string } } | null } | null } | null } | null };

export type TicketCardFragment = { id: string, code: string, used: boolean, usedAt?: string | null, firstName: string, lastName: string, email: string, phone: string, boughtAt?: string | null, ticketset?: { id?: number | null, name: string, event: { id?: number | null, name: string } } | null };

export type TicketDetailFragment = { ticketNumber: string, validUntil?: string | null, id: string, code: string, used: boolean, usedAt?: string | null, firstName: string, lastName: string, email: string, phone: string, boughtAt?: string | null, ticketset?: { id?: number | null, name: string, event: { id?: number | null, name: string } } | null };

export type AdminTicketInfoDataQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type AdminTicketInfoDataQuery = { admin?: { ticket?: { infoData?: { ok?: boolean | null, message?: string | null, email?: string | null, entries?: number | null, entryPause?: number | null, people?: number | null, eventId?: number | null, eventBzucoId?: number | null, eventName?: string | null, ticketsetId?: number | null, ticketsetBzucoId?: number | null, ticketsetName?: string | null, priceId?: number | null, priceBzucoId?: number | null, priceName?: string | null, created?: string | null, validUntil?: string | null, remainingEntriesForZone?: Array<{ id?: number | null, name?: string | null, count?: number | null } | null> | null, remainingPeopleForZone?: Array<{ id?: number | null, name?: string | null, count?: number | null } | null> | null, zones?: Array<{ id?: number | null, bzucoId?: number | null, name?: string | null } | null> | null, slots?: Array<{ id?: number | null, bzucoId?: number | null, startAt?: string | null } | null> | null, usageForZone?: Array<{ id?: number | null, name?: string | null, used?: boolean | null, usedAt?: string | null, usedBy?: string | null, extra?: string | null, display?: string | null, remains?: number | null, entries?: number | null, nextEntryAt?: string | null } | null> | null, usageLogs?: Array<{ created?: string | null, deviceId?: number | null, deviceName?: string | null, zoneId?: number | null, zoneName?: string | null } | null> | null } | null } | null } | null };

export type AdminTicketsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['ID']['input']>;
  ticketset?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminTicketsQuery = { admin?: { ticket?: { list?: { totalCount?: number | null, edges: Array<{ cursor: string, node?: { id: string, code: string, used: boolean, usedAt?: string | null, firstName: string, lastName: string, email: string, phone: string, boughtAt?: string | null, ticketset?: { id?: number | null, name: string, event: { id?: number | null, name: string } } | null } | null } | null>, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null };

export type AdminUpdateTicketMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  usedAt?: InputMaybe<Scalars['String']['input']>;
  boughtAt?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminUpdateTicketMutation = { admin?: { ticket?: { update?: { ok?: boolean | null } | null } | null } | null };

export type AdminUploadTicketsMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['Int']['input']>;
  ticketsJson: Scalars['String']['input'];
}>;


export type AdminUploadTicketsMutation = { admin?: { ticket?: { upload?: { ok?: boolean | null, created: number, skipped: number, ticketsetsCreated: number, pricesCreated: number, errorCount: number, errors: Array<{ row: number, message: string }> } | null } | null } | null };

export type AdminTicketsetsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminTicketsetsListQuery = { admin?: { ticketset?: { list?: Array<{ id?: number | null, name: string, customName: string, prefix: string, validate: boolean, entries: number, entryPause: number, unlimited: boolean, bzucoId: number, ticketCount?: number | null, validatedCount?: number | null, event: { id?: number | null, name: string }, prices: Array<{ id?: number | null, name: string, title: string, people: number, price: number, currency: string }> } | null> | null } | null } | null };

export type AdminUpdateTicketsetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  validate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminUpdateTicketsetMutation = { admin?: { ticketset?: { update?: { ok?: boolean | null } | null } | null } | null };

export type AdminUsersListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUsersListQuery = { admin?: { user?: { list?: Array<{ id?: number | null, username: string, firstName: string, lastName: string, email: string, isActive: boolean, isSuperuser: boolean, isStaff: boolean, lastLogin?: string | null, dateJoined: string, profile?: { validUntil?: string | null } | null, instances?: Array<{ id: string, primary: boolean, bzucoAdmin: boolean, allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean, instance: { id: string, name: string } } | null> | null } | null> | null } | null } | null };

export type AdminUserDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminUserDetailQuery = { admin?: { user?: { detail?: { id?: number | null, username: string, firstName: string, lastName: string, email: string, isActive: boolean, isSuperuser: boolean, isStaff: boolean, lastLogin?: string | null, dateJoined: string, profile?: { validUntil?: string | null } | null, instances?: Array<{ id: string, primary: boolean, bzucoAdmin: boolean, allowManageUsers: boolean, allowManageEvents: boolean, allowManageTicketsets: boolean, allowManageTickets: boolean, allowManageDevices: boolean, allowStats: boolean, instance: { id: string, name: string } } | null> | null } | null } | null } | null };

export type AdminUpdateUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUpdateUserMutation = { admin?: { user?: { update?: { ok?: boolean | null } | null } | null } | null };

export type AdminDeleteUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminDeleteUserMutation = { admin?: { user?: { delete?: { ok?: boolean | null } | null } | null } | null };

export type AdminUpdateUserRightsMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  instanceId: Scalars['Int']['input'];
  bzucoAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageUsers?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageEvents?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageTicketsets?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageTickets?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageDevices?: InputMaybe<Scalars['Boolean']['input']>;
  allowStats?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminUpdateUserRightsMutation = { admin?: { user?: { updateRights?: { ok?: boolean | null } | null } | null } | null };

export type AdminZonesListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminZonesListQuery = { admin?: { zones?: { list?: Array<{ id: string, name: string, validSince: number, validUntil: number, slots: Array<{ id: string, start: string, end?: string | null }> } | null> | null } | null } | null };

export const LoggedUserFragmentDoc = gql`
    fragment LoggedUser on UserType {
  id
  username
  firstName
  lastName
  email
  isSuperuser
  activeInstance {
    id
    name
  }
  instances {
    id
    instance {
      id
      name
    }
    primary
    bzucoAdmin
    allowManageUsers
    allowManageEvents
    allowManageTicketsets
    allowManageTickets
    allowManageDevices
    allowStats
  }
  rights {
    allowManageUsers
    allowManageEvents
    allowManageTicketsets
    allowManageTickets
    allowManageDevices
    allowStats
  }
}
    `;
export const TicketCardFragmentDoc = gql`
    fragment TicketCard on TicketType {
  id
  code
  used
  usedAt
  firstName
  lastName
  email
  phone
  boughtAt
  ticketset {
    id
    name
    event {
      id
      name
    }
  }
}
    `;
export const TicketDetailFragmentDoc = gql`
    fragment TicketDetail on TicketType {
  ...TicketCard
  ticketNumber
  validUntil
}
    ${TicketCardFragmentDoc}`;
export const AdminChangeInstanceDocument = gql`
    mutation AdminChangeInstance($instanceName: String!) {
  admin {
    user {
      changeInstance(instanceName: $instanceName) {
        ok
        instanceId
        rights {
          allowManageUsers
          allowManageEvents
          allowManageTicketsets
          allowManageTickets
          allowManageDevices
          allowStats
        }
      }
    }
  }
}
    `;
export const AdminCurrentUserDocument = gql`
    query AdminCurrentUser {
  admin {
    user {
      logged {
        ...LoggedUser
      }
    }
  }
}
    ${LoggedUserFragmentDoc}`;
export const AdminLoginDocument = gql`
    mutation AdminLogin($username: String!, $password: String!) {
  admin {
    user {
      login(username: $username, password: $password) {
        ok
        user {
          ...LoggedUser
        }
      }
    }
  }
}
    ${LoggedUserFragmentDoc}`;
export const AdminLogoutDocument = gql`
    mutation AdminLogout {
  admin {
    user {
      logout {
        ok
      }
    }
  }
}
    `;
export const AdminDashboardGetDocument = gql`
    query AdminDashboardGet($limit: Int) {
  admin {
    dashboard {
      get(limit: $limit) {
        validationsLast24h
        validationsPrev24h
        hourlyValidations
        ticketsTotal
        ticketsUsed
        activeDevicesCount
        totalDevicesCount
        upcomingEventsCount
        activeEvents {
          id
          name
          startAt
          endAt
          ticketsTotal
          ticketsUsed
          scanRateLastHour
        }
        recentScans {
          id
          createdAt
          deviceName
          ticketCode
          ticketsetName
          eventName
        }
        alerts {
          kind
          severity
          relatedId
          relatedType
          relatedName
        }
      }
      instances {
        id
        name
        activeEventsCount
        scansLast24h
        devicesOnline
        devicesTotal
      }
    }
  }
}
    `;
export const AdminDeviceCredentialsDocument = gql`
    query AdminDeviceCredentials($id: Int!) {
  admin {
    device {
      detail(id: $id) {
        id
        username
        password
      }
    }
  }
}
    `;
export const AdminDevicesListDocument = gql`
    query AdminDevicesList {
  admin {
    device {
      list {
        id
        name
        username
      }
    }
  }
}
    `;
export const AdminDeviceDetailDocument = gql`
    query AdminDeviceDetail($id: Int!) {
  admin {
    device {
      detail(id: $id) {
        id
        name
        username
      }
    }
  }
}
    `;
export const AdminCreateDeviceDocument = gql`
    mutation AdminCreateDevice($name: String, $username: String!, $password: String!) {
  admin {
    device {
      create(name: $name, username: $username, password: $password) {
        ok
      }
    }
  }
}
    `;
export const AdminUpdateDeviceDocument = gql`
    mutation AdminUpdateDevice($id: Int!, $name: String, $username: String, $password: String) {
  admin {
    device {
      update(id: $id, name: $name, username: $username, password: $password) {
        ok
      }
    }
  }
}
    `;
export const AdminDeleteDeviceDocument = gql`
    mutation AdminDeleteDevice($id: Int!) {
  admin {
    device {
      delete(id: $id) {
        ok
      }
    }
  }
}
    `;
export const AdminEventsListDocument = gql`
    query AdminEventsList {
  admin {
    event {
      list {
        id
        name
        startAt
        endAt
        bzucoId
      }
    }
  }
}
    `;
export const AdminEventDetailDocument = gql`
    query AdminEventDetail($id: Int!) {
  admin {
    event {
      detail(id: $id) {
        id
        name
        startAt
        endAt
        bzucoId
      }
    }
  }
}
    `;
export const AdminCreateEventDocument = gql`
    mutation AdminCreateEvent($name: String!, $startAt: String, $endAt: String) {
  admin {
    event {
      create(name: $name, startAt: $startAt, endAt: $endAt) {
        ok
      }
    }
  }
}
    `;
export const AdminUpdateEventDocument = gql`
    mutation AdminUpdateEvent($id: Int!, $name: String, $startAt: String, $endAt: String) {
  admin {
    event {
      update(id: $id, name: $name, startAt: $startAt, endAt: $endAt) {
        ok
      }
    }
  }
}
    `;
export const AdminDeleteEventDocument = gql`
    mutation AdminDeleteEvent($id: Int!) {
  admin {
    event {
      delete(id: $id) {
        ok
      }
    }
  }
}
    `;
export const AdminLookupDevicesDocument = gql`
    query AdminLookupDevices {
  admin {
    device {
      list {
        id
        name
        username
      }
    }
  }
}
    `;
export const AdminLookupEventsDocument = gql`
    query AdminLookupEvents {
  admin {
    event {
      list {
        id
        name
      }
    }
  }
}
    `;
export const AdminLookupTicketsetsDocument = gql`
    query AdminLookupTicketsets {
  admin {
    ticketset {
      list {
        id
        name
        bzucoId
        event {
          id
        }
        prices {
          id
          name
          bzucoId
        }
      }
    }
  }
}
    `;
export const AdminStatisticsGetDocument = gql`
    query AdminStatisticsGet($eventIds: [Int], $devices: [String], $dateFrom: DateTime, $dateTo: DateTime, $interval: StatisticsIntervalEnum, $showEmptyTicketsets: Boolean) {
  admin {
    statistics {
      get(
        eventIds: $eventIds
        devices: $devices
        dateFrom: $dateFrom
        dateTo: $dateTo
        interval: $interval
        showEmptyTicketsets: $showEmptyTicketsets
      ) {
        ticketsTotal
        ticketsValidated
        labels
        device {
          id
          username
          name
          values
          count
        }
        ticketsetSums {
          id
          total
          used
          real
          realNodevice
          eventName
          name
          sub {
            id
            name
            count
            type
          }
        }
        ticketsetSumsTotal {
          id
          total
          used
          real
          realNodevice
          name
          eventName
        }
      }
    }
  }
}
    `;
export const AdminDeleteTicketDocument = gql`
    mutation AdminDeleteTicket($id: Int!) {
  admin {
    ticket {
      delete(id: $id) {
        ok
      }
    }
  }
}
    `;
export const AdminDeleteTicketsMultiDocument = gql`
    mutation AdminDeleteTicketsMulti($ids: [Int]!) {
  admin {
    ticket {
      deleteMulti(ids: $ids) {
        ok
      }
    }
  }
}
    `;
export const AdminTicketDetailDocument = gql`
    query AdminTicketDetail($id: Int!) {
  admin {
    ticket {
      detail(id: $id) {
        ...TicketDetail
      }
    }
  }
}
    ${TicketDetailFragmentDoc}`;
export const AdminTicketInfoDataDocument = gql`
    query AdminTicketInfoData($code: String!) {
  admin {
    ticket {
      infoData(code: $code) {
        ok
        message
        email
        entries
        entryPause
        people
        eventId
        eventBzucoId
        eventName
        ticketsetId
        ticketsetBzucoId
        ticketsetName
        priceId
        priceBzucoId
        priceName
        created
        validUntil
        remainingEntriesForZone {
          id
          name
          count
        }
        remainingPeopleForZone {
          id
          name
          count
        }
        zones {
          id
          bzucoId
          name
        }
        slots {
          id
          bzucoId
          startAt
        }
        usageForZone {
          id
          name
          used
          usedAt
          usedBy
          extra
          display
          remains
          entries
          nextEntryAt
        }
        usageLogs {
          created
          deviceId
          deviceName
          zoneId
          zoneName
        }
      }
    }
  }
}
    `;
export const AdminTicketsDocument = gql`
    query AdminTickets($first: Int!, $after: String, $event: ID, $ticketset: ID, $search: String, $code: String, $email: String, $firstName: String, $lastName: String, $used: Boolean, $orderBy: String) {
  admin {
    ticket {
      list(
        first: $first
        after: $after
        event: $event
        ticketset: $ticketset
        search: $search
        code: $code
        email: $email
        firstName: $firstName
        lastName: $lastName
        used: $used
        orderBy: $orderBy
      ) {
        edges {
          cursor
          node {
            ...TicketCard
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  }
}
    ${TicketCardFragmentDoc}`;
export const AdminUpdateTicketDocument = gql`
    mutation AdminUpdateTicket($id: Int!, $code: String, $email: String, $firstName: String, $lastName: String, $phone: String, $used: Boolean, $usedAt: String, $boughtAt: String, $validUntil: String, $ticketNumber: String, $priceId: Int) {
  admin {
    ticket {
      update(
        id: $id
        code: $code
        email: $email
        firstName: $firstName
        lastName: $lastName
        phone: $phone
        used: $used
        usedAt: $usedAt
        boughtAt: $boughtAt
        validUntil: $validUntil
        ticketNumber: $ticketNumber
        priceId: $priceId
      ) {
        ok
      }
    }
  }
}
    `;
export const AdminUploadTicketsDocument = gql`
    mutation AdminUploadTickets($eventId: Int, $ticketsJson: String!) {
  admin {
    ticket {
      upload(eventId: $eventId, ticketsJson: $ticketsJson) {
        ok
        created
        skipped
        ticketsetsCreated
        pricesCreated
        errorCount
        errors {
          row
          message
        }
      }
    }
  }
}
    `;
export const AdminTicketsetsListDocument = gql`
    query AdminTicketsetsList {
  admin {
    ticketset {
      list {
        id
        name
        customName
        prefix
        validate
        entries
        entryPause
        unlimited
        bzucoId
        ticketCount
        validatedCount
        event {
          id
          name
        }
        prices {
          id
          name
          title
          people
          price
          currency
        }
      }
    }
  }
}
    `;
export const AdminUpdateTicketsetDocument = gql`
    mutation AdminUpdateTicketset($id: Int!, $name: String, $customName: String, $validate: Boolean) {
  admin {
    ticketset {
      update(id: $id, name: $name, customName: $customName, validate: $validate) {
        ok
      }
    }
  }
}
    `;
export const AdminUsersListDocument = gql`
    query AdminUsersList {
  admin {
    user {
      list {
        id
        username
        firstName
        lastName
        email
        isActive
        isSuperuser
        isStaff
        lastLogin
        dateJoined
        profile {
          validUntil
        }
        instances {
          id
          instance {
            id
            name
          }
          primary
          bzucoAdmin
          allowManageUsers
          allowManageEvents
          allowManageTicketsets
          allowManageTickets
          allowManageDevices
          allowStats
        }
      }
    }
  }
}
    `;
export const AdminUserDetailDocument = gql`
    query AdminUserDetail($id: Int!) {
  admin {
    user {
      detail(id: $id) {
        id
        username
        firstName
        lastName
        email
        isActive
        isSuperuser
        isStaff
        lastLogin
        dateJoined
        profile {
          validUntil
        }
        instances {
          id
          instance {
            id
            name
          }
          primary
          bzucoAdmin
          allowManageUsers
          allowManageEvents
          allowManageTicketsets
          allowManageTickets
          allowManageDevices
          allowStats
        }
      }
    }
  }
}
    `;
export const AdminUpdateUserDocument = gql`
    mutation AdminUpdateUser($id: Int!, $firstName: String, $lastName: String, $email: String, $isActive: Boolean, $isSuperuser: Boolean, $validUntil: String) {
  admin {
    user {
      update(
        id: $id
        firstName: $firstName
        lastName: $lastName
        email: $email
        isActive: $isActive
        isSuperuser: $isSuperuser
        validUntil: $validUntil
      ) {
        ok
      }
    }
  }
}
    `;
export const AdminDeleteUserDocument = gql`
    mutation AdminDeleteUser($id: Int!) {
  admin {
    user {
      delete(id: $id) {
        ok
      }
    }
  }
}
    `;
export const AdminUpdateUserRightsDocument = gql`
    mutation AdminUpdateUserRights($userId: Int!, $instanceId: Int!, $bzucoAdmin: Boolean, $allowManageUsers: Boolean, $allowManageEvents: Boolean, $allowManageTicketsets: Boolean, $allowManageTickets: Boolean, $allowManageDevices: Boolean, $allowStats: Boolean) {
  admin {
    user {
      updateRights(
        userId: $userId
        instanceId: $instanceId
        bzucoAdmin: $bzucoAdmin
        allowManageUsers: $allowManageUsers
        allowManageEvents: $allowManageEvents
        allowManageTicketsets: $allowManageTicketsets
        allowManageTickets: $allowManageTickets
        allowManageDevices: $allowManageDevices
        allowStats: $allowStats
      ) {
        ok
      }
    }
  }
}
    `;
export const AdminZonesListDocument = gql`
    query AdminZonesList {
  admin {
    zones {
      list {
        id
        name
        validSince
        validUntil
        slots {
          id
          start
          end
        }
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AdminChangeInstance(variables: AdminChangeInstanceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminChangeInstanceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminChangeInstanceMutation>({ document: AdminChangeInstanceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminChangeInstance', 'mutation', variables);
    },
    AdminCurrentUser(variables?: AdminCurrentUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCurrentUserQuery>({ document: AdminCurrentUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminCurrentUser', 'query', variables);
    },
    AdminLogin(variables: AdminLoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLoginMutation>({ document: AdminLoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminLogin', 'mutation', variables);
    },
    AdminLogout(variables?: AdminLogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminLogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLogoutMutation>({ document: AdminLogoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminLogout', 'mutation', variables);
    },
    AdminDashboardGet(variables?: AdminDashboardGetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDashboardGetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDashboardGetQuery>({ document: AdminDashboardGetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDashboardGet', 'query', variables);
    },
    AdminDeviceCredentials(variables: AdminDeviceCredentialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDeviceCredentialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeviceCredentialsQuery>({ document: AdminDeviceCredentialsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDeviceCredentials', 'query', variables);
    },
    AdminDevicesList(variables?: AdminDevicesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDevicesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDevicesListQuery>({ document: AdminDevicesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDevicesList', 'query', variables);
    },
    AdminDeviceDetail(variables: AdminDeviceDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDeviceDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeviceDetailQuery>({ document: AdminDeviceDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDeviceDetail', 'query', variables);
    },
    AdminCreateDevice(variables: AdminCreateDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminCreateDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateDeviceMutation>({ document: AdminCreateDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminCreateDevice', 'mutation', variables);
    },
    AdminUpdateDevice(variables: AdminUpdateDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUpdateDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateDeviceMutation>({ document: AdminUpdateDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUpdateDevice', 'mutation', variables);
    },
    AdminDeleteDevice(variables: AdminDeleteDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDeleteDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteDeviceMutation>({ document: AdminDeleteDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDeleteDevice', 'mutation', variables);
    },
    AdminEventsList(variables?: AdminEventsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminEventsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminEventsListQuery>({ document: AdminEventsListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminEventsList', 'query', variables);
    },
    AdminEventDetail(variables: AdminEventDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminEventDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminEventDetailQuery>({ document: AdminEventDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminEventDetail', 'query', variables);
    },
    AdminCreateEvent(variables: AdminCreateEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminCreateEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminCreateEventMutation>({ document: AdminCreateEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminCreateEvent', 'mutation', variables);
    },
    AdminUpdateEvent(variables: AdminUpdateEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUpdateEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateEventMutation>({ document: AdminUpdateEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUpdateEvent', 'mutation', variables);
    },
    AdminDeleteEvent(variables: AdminDeleteEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDeleteEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteEventMutation>({ document: AdminDeleteEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDeleteEvent', 'mutation', variables);
    },
    AdminLookupDevices(variables?: AdminLookupDevicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminLookupDevicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLookupDevicesQuery>({ document: AdminLookupDevicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminLookupDevices', 'query', variables);
    },
    AdminLookupEvents(variables?: AdminLookupEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminLookupEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLookupEventsQuery>({ document: AdminLookupEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminLookupEvents', 'query', variables);
    },
    AdminLookupTicketsets(variables?: AdminLookupTicketsetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminLookupTicketsetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminLookupTicketsetsQuery>({ document: AdminLookupTicketsetsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminLookupTicketsets', 'query', variables);
    },
    AdminStatisticsGet(variables?: AdminStatisticsGetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminStatisticsGetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminStatisticsGetQuery>({ document: AdminStatisticsGetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminStatisticsGet', 'query', variables);
    },
    AdminDeleteTicket(variables: AdminDeleteTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDeleteTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteTicketMutation>({ document: AdminDeleteTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDeleteTicket', 'mutation', variables);
    },
    AdminDeleteTicketsMulti(variables: AdminDeleteTicketsMultiMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDeleteTicketsMultiMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteTicketsMultiMutation>({ document: AdminDeleteTicketsMultiDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDeleteTicketsMulti', 'mutation', variables);
    },
    AdminTicketDetail(variables: AdminTicketDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminTicketDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTicketDetailQuery>({ document: AdminTicketDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminTicketDetail', 'query', variables);
    },
    AdminTicketInfoData(variables: AdminTicketInfoDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminTicketInfoDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTicketInfoDataQuery>({ document: AdminTicketInfoDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminTicketInfoData', 'query', variables);
    },
    AdminTickets(variables: AdminTicketsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminTicketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTicketsQuery>({ document: AdminTicketsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminTickets', 'query', variables);
    },
    AdminUpdateTicket(variables: AdminUpdateTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUpdateTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateTicketMutation>({ document: AdminUpdateTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUpdateTicket', 'mutation', variables);
    },
    AdminUploadTickets(variables: AdminUploadTicketsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUploadTicketsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUploadTicketsMutation>({ document: AdminUploadTicketsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUploadTickets', 'mutation', variables);
    },
    AdminTicketsetsList(variables?: AdminTicketsetsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminTicketsetsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminTicketsetsListQuery>({ document: AdminTicketsetsListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminTicketsetsList', 'query', variables);
    },
    AdminUpdateTicketset(variables: AdminUpdateTicketsetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUpdateTicketsetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateTicketsetMutation>({ document: AdminUpdateTicketsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUpdateTicketset', 'mutation', variables);
    },
    AdminUsersList(variables?: AdminUsersListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUsersListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUsersListQuery>({ document: AdminUsersListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUsersList', 'query', variables);
    },
    AdminUserDetail(variables: AdminUserDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUserDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUserDetailQuery>({ document: AdminUserDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUserDetail', 'query', variables);
    },
    AdminUpdateUser(variables: AdminUpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateUserMutation>({ document: AdminUpdateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUpdateUser', 'mutation', variables);
    },
    AdminDeleteUser(variables: AdminDeleteUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminDeleteUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminDeleteUserMutation>({ document: AdminDeleteUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminDeleteUser', 'mutation', variables);
    },
    AdminUpdateUserRights(variables: AdminUpdateUserRightsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUpdateUserRightsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUpdateUserRightsMutation>({ document: AdminUpdateUserRightsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUpdateUserRights', 'mutation', variables);
    },
    AdminZonesList(variables?: AdminZonesListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminZonesListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminZonesListQuery>({ document: AdminZonesListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminZonesList', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;